/* eslint-disable jsx-a11y/anchor-has-content */
import Link from "next/link";
import { chakra, useToken } from "@chakra-ui/react";
import { motion } from "framer-motion";
import { useEffect, useState } from "react";

const CustomLink = ({ href, ...rest }) => {
  const isInternalLink = href && href.startsWith("/");
  const isAnchorLink = href && href.startsWith("#");
  const [isHovered, setIsHovered] = useState(false);
  const red700 = useToken("colors", "red.700");

  const link = (
    <motion.a
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      animate={{
        textDecorationThickness: isHovered ? "5px" : "2px",
      }}
      transition={{
        duration: 0.06,
        ease: "easeInOut",
      }}
      style={{
        textDecoration: "underline",
        textDecorationColor: red700,
        textUnderlineOffset: "0.2em",
      }}
      target={isAnchorLink ? "_self" : "_blank"}
      href={href}
      {...rest}
    />
  );

  if (isInternalLink) {
    return (
      <Link href={href} legacyBehavior>
        {link}
      </Link>
    );
  } else {
    return link;
  }
};

export default CustomLink;
